import BasicModal from 'components/common/modal/BasicModal';
import * as React from 'react';
import { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import styled from 'styled-components';
import Button from 'components/common/Button';
import { initCredit } from 'api/backorder';

interface Props {
  groupId: string;
  onClose: () => void;
}
const CurrentCreditBalanceInitializationModal = ({ groupId, onClose }: Props) => {
  const [commentValue, setCommentValue] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const onConfirm = async () => {
    setIsLoading(true);
    await initCredit({ groupId, comment: commentValue });
    setIsLoading(false);
    window.location.reload();
  };

  const actionButton = (
    <>
      <Button variant={'text'} color={'secondary'} onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant={'text'}
        color={'primary'}
        onClick={onConfirm}
        disabled={!commentValue}
        isLoading={isLoading}
      >
        Confirm
      </Button>
    </>
  );

  return (
    <BasicModal open={true} onClose={onClose} actionButton={actionButton}>
      <Typography variant={'subtitle1'} color={'textPrimary'}>
        Are you sure you want to initialize the Credit Balance to 0.00?
      </Typography>
      <Comment>
        <Typography variant={'body2'} color={'textPrimary'} display={'inline'}>
          Comment
        </Typography>
        <Typography variant={'body2'} color={'error'} display={'inline'}>
          *
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant={'outlined'}
          value={commentValue}
          onChange={e => setCommentValue(e.target.value)}
          placeholder={'Please enter the reason for this initialization.'}
          inputProps={{
            maxLength: 500,
          }}
        />
      </Comment>
    </BasicModal>
  );
};

export default CurrentCreditBalanceInitializationModal;

const Comment = styled.div`
  margin-top: ${props => props.theme.spacing(5)}px;
`;
